import React, { useContext, useEffect } from 'react';
import { Menu, Layout, Typography, Badge } from 'antd';
import { Link } from 'react-router-dom';

import AuthenticationApi from 'services/authentication';
import { ProfileContext } from 'contexts/profile';

import './style.scss';

const { Sider } = Layout;
const { Title } = Typography;

const menuOptions = [
  {
    type: 'SubMenu',
    name: 'Orders',
    is_count: true,
    items: [
      {
        type: 'Menu',
        name: 'Orders',
        count_id: 'order_count',
        link: '/orders',
      },
      {
        type: 'Menu',
        name: 'Shipments',
        count_id: 'shipment_count',
        link: '/shipments',
      },
      // {
      //   type: 'Menu',
      //   name: 'Exchange',
      //   count_id: 'order_exchange_count',
      //   link: '/order_exchange',
      // },
      // {
      //   type: 'Menu',
      //   name: 'Refund',
      //   count_id: 'order_refund_count',
      //   link: '/order_refund',
      // },
      // {
      //   type: 'Menu',
      //   name: 'Returns',
      //   count_id: 'return_count',
      //   link: '/returns',
      // },
      // {
      //   type: 'Menu',
      //   name: 'Disbursements',
      //   count_id: 'disbursement_count',
      //   link: '/disbursements',
      // },
    ],
  },
  // {
  //   type: 'SubMenu',
  //   name: 'Rent',
  //   is_count: true,
  //   items: [
  //     {
  //       type: 'Menu',
  //       name: 'Orders',
  //       count_id: 'rent_order_count',
  //       link: '/rent_orders',
  //     },
  //     {
  //       type: 'Menu',
  //       name: 'Returns',
  //       count_id: 'rent_return_count',
  //       link: '/rent_returns',
  //     },
  //     {
  //       type: 'Menu',
  //       name: 'Exchange',
  //       count_id: 'rent_exchange_count',
  //       link: '/rent_exchange',
  //     },
  //     {
  //       type: 'Menu',
  //       name: 'Products',
  //       link: '/rent_products',
  //     },
  //     {
  //       type: 'Menu',
  //       name: 'Duration',
  //       link: '/rent_durations',
  //     },
  //     {
  //       type: 'Menu',
  //       name: 'Blackout Date',
  //       link: '/blackout_dates',
  //     },
  //   ],
  // },
  {
    type: 'SubMenu',
    name: 'Pick Up Point',
    items: [
      {
        type: 'Menu',
        name: 'Pick Up Point Location',
        link: '/pickup_points/location',
      },
      {
        type: 'Menu',
        name: 'Outbound Order',
        link: '/pickup_points/outbound-order',
      },
      {
        type: 'Menu',
        name: 'Inbound Order',
        link: '/pickup_points/inbound-order',
      },
    ],
  },
  {
    type: 'SubMenu',
    name: 'Stock Management',
    items: [
      {
        type: 'Menu',
        name: 'Location',
        link: '/locations',
      },
      {
        type: 'Menu',
        name: 'Warehouse',
        link: '/warehouses',
      },
      {
        type: 'Menu',
        name: 'Buy Stock',
        link: '/stocks',
      },
      // {
      //   type: 'Menu',
      //   name: 'Rent Stock',
      //   link: '/rent-stocks',
      // },
    ],
  },
  {
    type: 'SubMenu',
    name: 'Resellers',
    items: [
      {
        type: 'Menu',
        name: 'Landing Page',
        link: '/resellers_page',
      },
      {
        type: 'Menu',
        name: 'Reseller Status',
        link: '/resellers_status',
      },
      {
        type: 'Menu',
        name: 'Active Resellers',
        link: '/resellers_active',
      },
      {
        type: 'Menu',
        name: 'Cashback',
        link: '/resellers_cashback',
      },
      {
        type: 'Menu',
        name: 'Withdrawal',
        link: '/resellers_withdrawal',
      },
      {
        type: 'Menu',
        name: 'Orders',
        link: '/resellers_orders',
      },
    ],
  },

  {
    type: 'SubMenu',
    name: 'Home',
    items: [
      {
        type: 'Menu',
        name: 'Banners',
        link: '/banners',
      },
      {
        type: 'Menu',
        name: 'Category Sections',
        link: '/category-sections',
      },
      {
        type: 'Menu',
        name: 'Collections',
        link: '/collections',
      },
      {
        type: 'Menu',
        name: 'Promos',
        link: '/promo-section',
      },
      {
        type: 'Menu',
        name: 'Product Section',
        link: '/product-section',
      },
    ],
  },
  {
    type: 'SubMenu',
    name: 'Products',
    items: [
      {
        type: 'Menu',
        name: 'Products',
        link: '/products',
      },
      {
        type: 'Menu',
        name: 'Media',
        link: '/media_products',
      },
      {
        type: 'Menu',
        name: 'Categories',
        link: '/categories',
      },
      {
        type: 'Menu',
        name: 'Brands',
        link: '/brands',
      },
      {
        type: 'Menu',
        name: 'Fee',
        link: '/fee',
      },
    ],
  },
  {
    type: 'SubMenu',
    name: 'Promos',
    items: [
      {
        type: 'Menu',
        name: 'Promos',
        link: '/promos',
      },
      {
        type: 'Menu',
        name: 'Discounts',
        link: '/discounts',
      },
      // {
      //   type: 'Menu',
      //   name: 'Flash Sales',
      //   link: '/flash_sales',
      // },
    ],
  },

  {
    type: 'SubMenu',
    name: 'Customers',
    items: [
      { type: 'Menu', name: 'Customer List', link: '/customers' },
      { type: 'Menu', name: 'Wallet Activity', link: '/customer-wallet' },
    ],
  },

  {
    type: 'Menu',
    name: 'Couriers',
    link: '/couriers',
  },
  // {
  //   type: 'Menu',
  //   name: 'Risk Management',
  //   link: '/risk_managements',
  // },
  // {
  //   type: 'SubMenu',
  //   name: 'Penalty',
  //   items: [
  //     { type: 'Menu', name: 'Penalty Setting', link: '/penalties' },
  //     {
  //       type: 'Menu',
  //       name: 'Checking Inspection',
  //       link: '/review_inspections',
  //     },
  //   ],
  // },
  // {
  //   type: 'Menu',
  //   name: 'Inspection',
  //   link: '/inspections',
  // },
  {
    type: 'SubMenu',
    name: 'Admins',
    items: [
      {
        type: 'Menu',
        name: 'Admins',
        link: '/admins',
      },
      {
        type: 'Menu',
        name: 'Roles',
        link: '/roles',
      },
      {
        type: 'Menu',
        name: 'Activities',
        link: '/activities',
      },
    ],
  },
  {
    type: 'Menu',
    name: 'Search Suggestion',
    link: '/search_suggestions',
  },
  {
    type: 'Menu',
    name: 'About Us',
    link: '/about_us_pages',
  },
  {
    type: 'Menu',
    name: 'Terms and Policy',
    link: '/terms_and_conditions',
  },
  {
    type: 'Menu',
    name: 'Edit Profile',
    link: '/profile',
  },
];

export function Sidebar() {
  const { pageList, fetchProfile, orderCount } = useContext(ProfileContext);

  useEffect(() => {
    fetchProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCounterSubMenu = (initValue) => {
    const keys = Object.keys(orderCount);
    // check if there is value in orderCount
    let is_countValue = keys.some((key) => {
      return orderCount[key] > 0;
    });
    // if order_count only have 0 value return initial state
    return is_countValue ? initValue : is_countValue;
  };

  const handleCounterMenu = (counter_id) => {
    return counter_id !== '' ? orderCount[counter_id] : 0;
  };

  // Transform menuOptions to Ant Design Menu items format
  const transformToMenuItems = (options) => {
    return options
      .map((opt) => {
        const { name, link, count_id, is_count, type, items: children = [] } = opt;

        if (type === 'Menu') {
          // Check if this menu item should be shown
          const isVisible =
            pageList.some(
              (list) =>
                list.page === link.split('/')[1] ||
                (list.page.includes('products') && link === '/rent_products') ||
                (list.page.includes('products') && link === '/media_products') ||
                (list.page.includes('orders') && link === '/rent_orders') ||
                (list.page.includes('resellers') && link.includes('/resellers'))
            );

          if (!isVisible) return null;

          return {
            key: link,
            label: (
              <Link to={link}>
                {name}
                <Badge count={handleCounterMenu(count_id)} />
              </Link>
            ),
          };
        } else {
          // SubMenu
          const visibleChildren = children.filter((child) =>
            pageList.some(
              (list) =>
                list.page === child.link.split('/')[1] ||
                (list.page.includes('products') && child.link === '/rent_products') ||
                (list.page.includes('orders') && child.link === '/rent_orders') ||
                (list.page.includes('resellers') && child.link.includes('/resellers'))
            )
          );

          if (visibleChildren.length === 0) return null;

          return {
            key: name,
            label: (
              <span>
                <Badge dot={handleCounterSubMenu(is_count)}>{name}</Badge>
              </span>
            ),
            children: visibleChildren.map((child) => ({
              key: child.link,
              label: (
                <Link to={child.link}>
                  {child.name}
                  <Badge count={handleCounterMenu(child.count_id || '')} />
                </Link>
              ),
            })),
          };
        }
      })
      .filter(Boolean);
  };

  const menuItems = transformToMenuItems(menuOptions);

  async function handleLogout() {
    const cms_token = localStorage.getItem('cms_token');

    if (cms_token) {
      AuthenticationApi.logout(cms_token);
      localStorage.removeItem('cms_token');
      localStorage.removeItem('current_admin');
      window.location.reload();
    }
  }

  return (
    <Sider width="300" className="pd-cms-sidebar">
      <div className="wrapper">
        <div className="menu">
          <Title level={3}>
            <Link to={'/'}>
              <img
                src={`/img/logo/homestory.png`}
                width="175"
                alt="logo homestory"
              />
            </Link>
          </Title>
          <Menu mode="inline" items={menuItems} />
        </div>
        <div className="user-badge">
          <Title level={4} onClick={handleLogout}>
            <Link to={'/login'}>Logout</Link>
          </Title>
        </div>
      </div>
    </Sider>
  );
}

export default { Sidebar };
